import React from "react";
import "./PhoneDisplay.css";

const PhoneDisplay = ({ phone = "+91 90100 90200" }) => {
  return (
    <span className="phone-display-text">
      {phone}
    </span>
  );
};

export default PhoneDisplay;
